import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import {Box} from "@mui/system";
import {Field, reduxForm} from "redux-form";
import {required, validate} from "_helpers";
import {authorizationActions} from "_actions";
import BasicTextField from "../../../common/BasicTextField";
import VerticalSelect from "./VerticalSelect";
import PasswordGroup from "./Password/PasswordGroup";
import SignupButton from "./SignupButton";
import LegalCheckboxLabel from "./LegalCheckboxLabel";
import ShopifyMetaData from "./ShopifyMetaData";
import {signupSource} from "_constants";
import {parseQueryParams} from "./SignupUtils";

const initialQueryValues = parseQueryParams();
const isShopify = initialQueryValues.isShopify;

function SignupForm({ handleSubmit }) {
    const dispatch = useDispatch();
    const [active, setActive] = React.useState(false);
    const [agreement, setAgreement] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleVisibility = (value) => {
        setActive(value);
    };

    const handleSignup = (values) => {
        const { signupOrigin, shop, ...rest } = values;
        const normalizedOrigin = signupOrigin?.toUpperCase();

        const payload = {
            ...rest,
            ...(normalizedOrigin && { signupOrigin: normalizedOrigin }),
            ...(normalizedOrigin === signupSource.SHOPIFY && { shopifyMetadata: { shop } })
        };

        dispatch(authorizationActions.companySignup(payload));
    };


    const handleAgreement = (event) => {
        event.stopPropagation();
        setAgreement(event.target.checked);
    }

    const authorization = useSelector((state) => state.authorization);
    const { signupLoading } = authorization;

    return(
        <Box sx={ isMobile ? styles.formContainerMobile :
            (active ? styles.formContainerWithPasswordChecker : styles.formContainer) }>

            <Box sx={styles.requiredLabel}
                 display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block'}}>
                All fields are required.
            </Box>

            <form name="form" onSubmit={handleSubmit(handleSignup)} autoComplete="off">
                <Box sx={{marginTop: '20px'}}>
                    <Field
                        name="firstName"
                        label="First name"
                        component={BasicTextField}
                        variant={"standard"}
                        validate={required}
                    />
                </Box>

                <Box sx={{marginTop: '25px'}}>
                    <Field
                        name="lastName"
                        label="Last name"
                        component={BasicTextField}
                        variant={"standard"}
                        validate={required}
                    />
                </Box>

                <Box sx={{marginTop: '25px'}}>
                    <Field
                        name="company"
                        label="Company"
                        component={BasicTextField}
                        variant={"standard"}
                        validate={required}
                    />
                </Box>

                {
                    isShopify &&
                    <ShopifyMetaData required={ isShopify && required } />
                }

                <Box sx={{marginTop: '25px'}}>
                    <Field
                        name="vertical"
                        label="Industry"
                        component={VerticalSelect}
                    />
                </Box>

                <Box sx={{marginTop: '25px'}}>
                    <Field
                        name="email"
                        label="Email"
                        component={BasicTextField}
                        variant={"standard"}
                        validate={required}
                    />
                </Box>

                <Box sx={{marginTop: '25px'}}>
                    <Field
                        name="password"
                        component={PasswordGroup}
                        handleVisibility={ handleVisibility }
                        validate={required}
                    />
                </Box>

                <Box sx={{marginTop: '20px'}}>
                    <LegalCheckboxLabel handleCheckbox={handleAgreement} />
                </Box>

                <Box sx={styles.buttonContainer}>
                    <SignupButton label={'Next'}
                                  disabled={signupLoading || !agreement}
                                  isLoading={signupLoading}
                    />
                </Box>
            </form>
        </Box>
    )
}

const styles = {
    formContainer: {
        height: 'auto',
        marginTop: '145px',
        marginBottom: '60px',
    },
    formContainerMobile: {
        height: 'auto',
        marginTop: '30px',
        marginBottom: '60px'
    },
    formContainerWithPasswordChecker: {
        height: 'auto',
        marginTop: '30px',
        marginBottom: '50px',
    },
    requiredLabel : {
        textAlign: 'right',
        fontSize: '15px',
        lineHeight: '21px',
        color: '#0f0a05',
        fontFamily: 'FustatRegular',
    },
    buttonContainer: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: "flex-end"
    },
};

const formConfig = {
    form: 'CompanySignupForm',
    initialValues: {
        isCompanyAdmin: true,
        terms: true,
        shop: initialQueryValues.shop,
        signupOrigin: initialQueryValues.signupOrigin,
        email: initialQueryValues.email,
        company: initialQueryValues.company,
        firstName: initialQueryValues.firstName,
        lastName: initialQueryValues.lastName,
    },
    validate,
};

export default reduxForm(formConfig)(SignupForm);